import { render } from "./SkeletonForBiometric.vue?vue&type=template&id=fcffaec2"
import script from "./SkeletonForBiometric.vue?vue&type=script&lang=js"
export * from "./SkeletonForBiometric.vue?vue&type=script&lang=js"

import "./SkeletonForBiometric.vue?vue&type=style&index=0&id=fcffaec2&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__